module.exports = __webpack_public_path__ + "img/logo_default.1c349798.png";